const zoneLinks = [
  { href: "#featured", label: "今日爆点" },
  { href: "#dorm", label: "宿舍迷惑" },
  { href: "#classroom", label: "课堂社死" },
  { href: "#duo", label: "同桌奇葩" },
  { href: "#duo", label: "群聊翻车" },
  { href: "#gossip", label: "课间八卦" },
];

const supportLinks = [
  { href: "#ranking", label: "吃瓜热榜" },
  { href: "#faq", label: "常见问题" },
  { href: "#submit", label: "我要投稿" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-primary-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-primary-50 text-2xl">
                🤣
              </span>
              <div>
                <p className="font-heading text-2xl text-white">校园爆笑社</p>
                <p className="text-xs tracking-[0.2em] text-primary-100/80">课间吃瓜聚集地</p>
              </div>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-primary-100/85">
              专注校园爆笑的内容站，汇聚宿舍生活搞笑爆料、课堂同学社死现场、校园同桌奇葩事与班级群聊翻车合集，
              让每个课间与熄灯后的夜晚都笑到停不下来。
            </p>
            <p className="mt-5 inline-flex items-center gap-2 rounded-full bg-primary-50/10 px-4 py-2 text-xs text-primary-100">
              <i className="ri-mail-line" /> baoxiao@xiaoyuanlaugh.com
            </p>
          </div>

          <nav>
            <h4 className="font-heading text-base text-white">栏目导航</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {zoneLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-primary-100/80 transition-colors hover:text-white">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav>
            <h4 className="font-heading text-base text-white">帮助支持</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {supportLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-primary-100/80 transition-colors hover:text-white">
                    {l.label}
                  </a>
                </li>
              ))}
              <li className="pt-2 text-xs text-primary-100/70">
                欢迎匿名投稿你的宿舍与课堂趣事，上架有惊喜。
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <div className="border-t border-primary-100/15">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-primary-100/70 sm:flex-row md:px-6">
          <p>© 2026 校园爆笑社 · 内容仅供娱乐分享，情节如有雷同纯属巧合</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-heart-fill text-white/70" /> 友善吃瓜 · 不造谣不引战
          </p>
        </div>
      </div>
    </footer>
  );
}